// Dependencies
import React, { Fragment, FunctionComponent, useState } from 'react'

// Components
import { Chat, ChatMessageBox, ChatMessageItem } from 'component-library/chat'
import { Icon } from 'component-library/icon/icon.component'

// Styles
import * as S from './styles'

// Assets
import whatsBtn from '../../assets/whats-button.png'

// Data
import data from './data'
import { chatData } from 'component-library/chat/chat.mocks'

// Types
interface IFooterInfo {
  message: string
  link: string
}

export const WhatsDoubts: FunctionComponent = () => {
  const footerData = data.chatInfo.footer

  const [isChatActive, setIsChatActive] = useState(false)
  const [isFooterActive, setIsFooterActive] = useState(false)
  const [footerInfo, setFooterInfo] = useState<IFooterInfo>({
    message: footerData.defaultLabel,
    link: '#'
  })
  const [chatMessageItemSelectedIndex, setChatMessageItemSelectedIndex] =
    useState(-1)

  const handleChat = () => {
    setIsChatActive(!isChatActive)
  }

  const handleFooter = (item: any) => {
    setFooterInfo({
      message: item.message,
      link: item.link
    })

    setIsFooterActive(true)
  }

  return (
    <>
      <S.Wrapper visible={isChatActive}>
        {isChatActive && (
          <Chat
            closeIconElement={
              <Icon
                name="close"
                color="#7c8195"
                handleClick={() => handleChat()}
              />
            }
            content={
              <Fragment>
                <ChatMessageBox
                  headerComposition={chatData.header.map(
                    (item: any, index: any) => (
                      <ChatMessageItem
                        key={`chat-message-item-header-${index}`}
                        type="header"
                        label={item.message}
                        isActive={false}
                      />
                    )
                  )}
                  messagesComposition={chatData.options.map(
                    (item: any, index: number) => (
                      <ChatMessageItem
                        key={`chat-message-item-option-${index}`}
                        type="option"
                        label={item.message}
                        isActive={chatMessageItemSelectedIndex === index}
                        handleClick={() => {
                          handleFooter(item)
                          setChatMessageItemSelectedIndex(index)
                        }}
                      />
                    )
                  )}
                />

                {isFooterActive && (
                  <S.ChatFooterContainer>
                    <span>{footerInfo.message}</span>

                    <Icon
                      name="sendChatFill"
                      color="#df1d3d"
                      size={48}
                      handleClick={() => window.open(footerInfo.link, '_blank')}
                    />
                  </S.ChatFooterContainer>
                )}
              </Fragment>
            }
          />
        )}

        {!isChatActive && (
          <S.WhatsappImage
            src={whatsBtn}
            alt="Botão do Whatsapp"
            onClick={() => handleChat()}
          />
        )}
      </S.Wrapper>
    </>
  )
}
